export const environment = {
  production: true,
  url: "https://devapp.oohlala.es/api/"
  
};